import React from "react";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import ButtonRounded from "../../../components/buttons/ButtonRounded";
import Badge from "../../../components/Common/Badge";
import { FaPlus } from "react-icons/fa6";
import PropTypes from "prop-types";
import { AppContext } from "../../../contexts/AppContext";
import { formataData } from "../../../helpers/mesesHelper";
import Format from "../../../helpers/Format";

function MeiDataTable({
  linhas,
  togNovoProcessoModal,
  togProcessoModal,
  deletarProcesso,
  finalizarProcesso,
}) {
  const { session } = React.useContext(AppContext);

  const colunas = React.useMemo(
    () => [
      {
        Header: "Nome",
        accessor: (row) => {
          return <h5 className="font-size-14">{row.razao_social}</h5>;
        },
      },
      {
        Header: "Criação",
        accessor: (row) => {
          return formataData(row.created_at.split("T")[0] ?? "");
        },
        disableSortBy: true,
      },
      {
        Header: "Mensalidade",
        accessor: (row) => {
          if (!row.dados_empresa) return Format.formataValor(0);
          const mensalidade = parseFloat(row.dados_empresa.mensalidade) || 0;
          return Format.formataValor(
            Number.isNaN(mensalidade) ? 0 : mensalidade
          );
        },
        disableSortBy: true,
      },
      {
        Header: "E-mail",
        accessor: (row) => {
          return row.dados_empresa && row.dados_empresa.email_empresa;
        },
      },
      {
        Header: "Status",
        accessor: "categoria",
        disableSortBy: true,
        Cell: ({ row }) => {
          let status = [];

          if (row.original.status === "INCOMPLETA") {
            status.push(<Badge color="warning">Cadastro incompleto</Badge>);
          } else if (row.original.status === "EM PROCESSAMENTO") {
            status.push(<Badge color="primary">Aguardando finalizar</Badge>);
          } else {
            status.push(<Badge color="success">Processo finalizado</Badge>);
          }

          return (
            <div>
              <div className="mb-2" role="group">
                {status}
              </div>
            </div>
          );
        },
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          var status = [];

          if (
            row.original.status === "INCOMPLETA" ||
            (session.codigo === "99" && row.original.status !== "CONCLUIDA")
          )
            status.push(
              <>
                <DropdownButton
                  key={`editar-${row.original.uid}`}
                  onClick={() => {
                    togProcessoModal(row.original.uid);
                  }}
                  color="warning"
                  icon="fas fa-folder-open"
                >
                  Editar dados
                </DropdownButton>
              </>
            );

          if (row.original.status === "EM PROCESSAMENTO")
            status.push(
              <>
                <DropdownButton
                  key={`finalizar-${row.original.uid}`}
                  onClick={() => {
                    finalizarProcesso(row.original, row.original.uid);
                  }}
                  color="success"
                  icon="fas fa-check-square"
                >
                  Finalizar processo
                </DropdownButton>
              </>
            );

          status.push(
            <>
              <DropdownButton
                key={`deletar-${row.original.uid}`}
                onClick={() => {
                  deletarProcesso(row.original.uid);
                }}
                color="danger"
                icon="fas fa-trash-alt"
              >
                Deletar processo
              </DropdownButton>
            </>
          );

          return <CommonDropdown>{status}</CommonDropdown>;
        },
      },
    ],
    [session, togProcessoModal, deletarProcesso, finalizarProcesso]
  );

  return (
    <CommonDataTable
      colunas={colunas}
      linhas={linhas}
      botoes={
        <ButtonRounded
          onClick={togNovoProcessoModal}
          color="success"
          icon={<FaPlus />}
        >
          Novo processo
        </ButtonRounded>
      }
    />
  );
}

MeiDataTable.propTypes = {
  linhas: PropTypes.arrayOf(PropTypes.object).isRequired,
  togNovoProcessoModal: PropTypes.func.isRequired,
  togProcessoModal: PropTypes.func.isRequired,
  deletarProcesso: PropTypes.func.isRequired,
  finalizarProcesso: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default MeiDataTable;
